// One dropdown open at a time (owner ruling, 2026-09-10).
//
// Two panels open at once is two answers to one question: the reader cannot tell
// which one a keystroke reaches, and on a filter bar the second one covers the
// first. Outside-click already closed most pairs, but it depends on event order —
// a panel that opens on focus can open before the previously-open one has seen
// the pointerdown that should have shut it. This is the deterministic version:
// opening claims the slot, and whoever held it is closed first.
//
// MUD's own `mud-select` closes itself on an outside click, so it
// needs no registration to close when one of ours opens. The other direction does
// need saying: `mudOpen` is the event it fires when its listbox appears, and it
// bubbles, so one listener at the document closes ours.
//
// Local to this page while it has one consumer. PRINCIPLES.md's rule of three
// says a second surface is what earns it a place in `libs/ui/shared`.

type CloseFn = () => void;

let openDropdown: CloseFn | null = null;
let listening = false;

function listenForAgeSelects(): void {
  if (listening || typeof document === 'undefined') return;
  listening = true;
  document.addEventListener('mudOpen', () => {
    const previous = openDropdown;
    openDropdown = null;
    previous?.();
  });
}

/** Opening a dropdown. Closes whichever one was open, unless it is this one. */
export function claimDropdown(close: CloseFn): void {
  listenForAgeSelects();
  if (openDropdown && openDropdown !== close) {
    const previous = openDropdown;
    openDropdown = null;
    previous();
  }
  openDropdown = close;
}

/** Closing one. Only clears the slot if this dropdown still holds it. */
export function releaseDropdown(close: CloseFn): void {
  if (openDropdown === close) openDropdown = null;
}
